module.exports = __webpack_public_path__ + "img/4.6f0413b6.jpg";